import userModule from "./modules/user";
import formModule from "./modules/form";
import {loader} from "./modules/loader";

const store = {
    modules: {
        loader: loader,
        user: userModule,
        form: formModule,
    },
    state: {
        apiHostname: null,
    },
    mutations: {
        setHostname(state) {
            if (state.apiHostname === null) {
                state.apiHostname = window.hostname;
            }
        },
    },
    getters: {},
    actions: {},
};

export default store;
